import { TableRow } from "@mui/material";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  locationState,
  setSelectedLocationAction,
} from "../../app/reducers/location-slice";
import theme from "../../style/theme";
import { ITEM_NUMBER_BY_PAGE } from "../../types/pages";
import ImageFillIcon from "../icons/ImageFillIcon/ImageFillIcon";

const tableHeaders = ["번호", "주소", "사진등록"];

export const LocationListTable = () => {
  const dispatch = useAppDispatch();
  const { selectedLocation, locationPage } = useAppSelector(locationState);

  const handleClickTableRow = (
    event: React.MouseEvent<HTMLTableRowElement>
  ) => {
    const selectedLocation = locationPage.contents.find(
      (Location) => Location.id === event.currentTarget.id
    );

    if (!selectedLocation) {
      return;
    }

    dispatch(setSelectedLocationAction({ selectedLocation }));
  };

  return (
    <LocationTableContainer>
      <Table>
        <TableRow>
          {tableHeaders.map((tableHeader, index) => (
            <LocationTableHeader key={tableHeader} index={index}>
              {tableHeader}
            </LocationTableHeader>
          ))}
        </TableRow>
        <LocationTableBody>
          {locationPage.contents.map((location, index) => {
            const isSelected = location.id === selectedLocation?.id;
            return (
              <LocationTableRow
                key={location.id}
                id={location.id}
                isSelected={isSelected}
                onClick={handleClickTableRow}
              >
                <LocationTableData>
                  {index + 1 + locationPage.page * ITEM_NUMBER_BY_PAGE}
                </LocationTableData>
                <LocationAddressTableData>{`${location.road} (${location.jibun})`}</LocationAddressTableData>
                <LocationTableData>
                  <ImageFillIcon
                    width={"1.438rem"}
                    height={"1.438rem"}
                    fill={
                      location.images.length > 0
                        ? `${theme.palette.primitives.gray400}`
                        : `${theme.palette.primitives.gray100}`
                    }
                  />
                </LocationTableData>
              </LocationTableRow>
            );
          })}
        </LocationTableBody>
      </Table>
    </LocationTableContainer>
  );
};

const LocationTableContainer = styled.div`
  height: 541px;
  border-radius: 4px;
  word-break: break-all;
`;
const Table = styled.table`
  width: 100%;
  overflow: hidden;
`;

interface LocationTableHeaderProps {
  index: number;
}

const LocationTableHeader = styled.th<LocationTableHeaderProps>`
  height: 3.188rem;
  text-align: ${(props) => (props.index === 1 ? "left" : "center")}};
  vertical-align: middle;
  background-color: ${theme.palette.primitives.gray50};
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.188rem;
  color: ${theme.palette.primitives.gray600};
  padding: 0 0.625rem;

  &:first-of-type {
    padding-left: 0px;
  }
  &:nth-last-of-type(1) {
    padding-right: 0px;
  }
`;
const LocationTableBody = styled.tbody``;

interface LocationTableRowProps {
  isSelected?: boolean;
}

const LocationTableRow = styled.tr<LocationTableRowProps>`
  height: 3.063rem;
  border-bottom: ${`1px solid ${theme.palette.primitives.gray100}`};
  background-color: ${(props) =>
    props.isSelected
      ? `${theme.palette.primitives.gray50}`
      : `${theme.palette.primitives.white}`};
  cursor: pointer;

  :hover {
    background-color: ${theme.palette.primitives.gray50};
  }
`;

const LocationTableData = styled.td`
  width: "12.5%";
  padding: 6px 0px;
  text-align: center;
  vertical-align: middle;
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.063rem;
  color: ${theme.palette.primitives.gray600};
  padding: 0 0.625rem;

  &:first-of-type {
    padding-left: 0px;
  }
  &:nth-last-of-type(1) {
    padding-right: 0px;
  }
`;

const LocationAddressTableData = styled.td`
  width: 75%;
  padding: 6px 0px;
  text-align: left;
  vertical-align: middle;
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.063rem;
  color: ${theme.palette.primitives.gray600};
  padding: 0 0.625rem;
`;

const LocationTableDataLabel = styled.div`
  margin: 0 auto;
  text-align: center;
  vertical-align: middle;
`;
